import styled from '@emotion/styled';

export const StatsContainer = styled.div`
    display: flex;
    background: white;
    border-radius: 10px;
    overflow: hidden;
    border: 2px solid #eceef6;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    margin-top: 30px;
`;

export const StatItem = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    text-align: center;
    padding: 8px 12px;
    border-right: 1px dashed #e0e0e0;

    &:last-child {
        border-right: none;
    }
`;

export const Header = styled.div`
    margin: auto;
`;

export const Label = styled.span`
    font-size: 18px;
    color: #666;
    margin-bottom: 4px;
    color: #565e6c;
`;

export const Value = styled.span`
    font-size: 24px;
    font-weight: bold;
    color: #5e2ced;
`;

export const ChangeIndicator = styled.span`
    display: inline-block;
    font-size: 12px;
    color: #5e2ced;
    margin-left: 6px;
    background-color: #f4f6f6;
    border-radius: 10px;
    padding: 2px;
`;
